import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from 'react-table';
// import * as R from 'ramda';
import * as toTitleCase from 'title-case';
import { LinkContainer } from 'react-router-bootstrap';
import {
  EditOutlined,
  FileSearchOutlined,
  // UserOutlined,
} from '@ant-design/icons';
import { Button } from 'antd';
import { isFeatureEnabled } from '../../../config/featureFlags';
import HorizontalScroll from '../../../components/horizontalScroll/index';

// Components
// import ManagePendingRequest from '../../../components/Modals/ManagePendingRequest';
// import { getOrgAdmins } from '../../../graphql/organizationDetails';
// import { UpdateOrganization } from '../../../graphql/organization';
import EditOrganization from '../../Modals/EditOrganization';
// Local Deps

import './PendingRequest.scss';
import './EdgeFix.scss';
import msgs from '../../../config/messages';
import { displayAssociations } from '../../Billsby/plans';
import { invitationRoute } from '../../../config/navigation/routes';
// import { getFiaOrgs, getNffsOrgs } from '../../../pages/Invitation/Invitation';
import ViewInvitation from '../../Modals/ViewInvitation/ViewInvitation';
import { sendInvitation } from '../../../pages/Invitation/Invitation';
import { filterMethod, otherFilter, setFilterPlaceholders, tooltipColumn, tooltipRow } from '../filterFunctions';
// import { updateUser, createUser } from '../../../graphql/updateUsers';
// import { createUser } from '../../../graphql/users';
// import { updateUserMetaData } from './graphql';

const stage = process.env.NODE_ENV;

const titleAcceptInvitation =
  `Accept the invitation as if you were the customer. This saves 
you the trouble of checking the email and accepting it there.`;
const titleView =
  `View information about this organization.`;
const titleSync =
  `Synchronize information for this organization on ICON
with information from the remote site.`;
const titleUpdate =
  `Update information for this organization on ICON
with information from the remote site.`;
const titleInvite =
  `Send an email to the POC of this organization,
inviting them join ICON.`;
export default class PendingRequest extends React.PureComponent {
  static propTypes = {
    auth: PropTypes.shape({
      jwtToken: PropTypes.string.isRequired,
      expiration: PropTypes.number.isRequired,
      organizationId: PropTypes.string.isRequired,
      role: PropTypes.string.isRequired,
    }).isRequired,
    requests: PropTypes.instanceOf(Array).isRequired,
    requestType: PropTypes.string.isRequired,
    // auth: PropTypes.object.isRequired,
    refreshOrganizations: PropTypes.func.isRequired,
    onUpdate: PropTypes.func,
  };

  static defaultProps = {
    onUpdate: () => { }
  };

  static initialState = {
    // modalDisplayed: false,
    // rowIndex: 0,
    // requestedAdmins: [],
    // selectedRowKeys: [],
    // action: null,
    selectedOrganizationId: undefined,
    viewItem: undefined,
    // orgType: null,
    // organizationUsers: [],
  };

  static formatRequest(requests) {
    return requests.map(request => ({
      ...request,
      entityName: request.name,
      iconStatus: request.iconStatus ? toTitleCase(request.iconStatus) : request.inviteDate ? 'Invited' : '',
    }));
  }

  state = PendingRequest.initialState;

  componentDidMount() {
    setFilterPlaceholders();
  }

  componentDidUpdate() {
    setFilterPlaceholders();
  }

  closeEditModal = () => {
    this.setState({
      showEditModal: false,
      selectedOrganizationId: undefined,
    });
  }

  openEditModal = (itemId) => {
    this.setState({
      showEditModal: true,
      selectedOrganizationId: itemId,
    });
  }

  closeViewModal = () => {
    this.setState({
      showViewModal: false,
    })
  }

  openViewModal = async (item) => {
    // const item = await getOrg(name);
    this.setState({
      showViewModal: true,
      viewItem: item,
    });
  }

  // searchMethod = (rows, columnIds, filterValue) => {
  //   return rows.filter(row => {
  //     return row.values[]
  //   })
  // }
  // _getIndex = async row => {
  //   const id = this.props.requests[row.index].id;

  //   this.setState({
  //     // rowIndex: row.index,
  //     selectedOrganizationId: id,
  //   });
  //   try {
  //     const response = await getOrgAdmins(id);
  //     this.setState({
  //       requestedAdmins: response.organization.admins,
  //       organizationUsers: response.organization.users,
  //       orgType: response.organization.organizationType,
  //     });
  //   } catch (err) {
  //     console.log(err);
  //   }
  //   this._ToggleModal(true);


  // };

  // _ToggleModal = modalDisplayed => this.setState({ modalDisplayed });

  // _changeOrg = e => {
  //   this.setState({
  //     orgType: e.target.value.toLowerCase(),
  //   });
  // };

  // selectRow = record => {
  //   const selectedRowKeys = [...this.state.selectedRowKeys];
  //   if (selectedRowKeys.indexOf(record.key) >= 0) {
  //     selectedRowKeys.splice(selectedRowKeys.indexOf(record.key), 1);
  //   } else {
  //     selectedRowKeys.push(record.key);
  //   }
  //   this.setState({ selectedRowKeys });
  // };

  // _onSelectedRowKeysChange = selectedRowKeys => {
  //   this.setState({ selectedRowKeys });
  // };

  // _onSelectedAction = selectedAction => {
  //   this.setState({
  //     action: selectedAction,
  //   });
  // };

  // _denyAdmin = deniedAdmins => {
  //   deniedAdmins.map(deniedAdmin => {
  //     deniedAdmin.role = 'user';
  //     delete deniedAdmin.key;
  //     delete deniedAdmin.index;
  //     updateUser(deniedAdmin);


  //     return deniedAdmin;
  //   });
  //   return '';
  // };

  // _handleOrg = async () => {
  //   const org = {
  //     organizationType: this.state.orgType,
  //     iconStatus: this.state.action,
  //     id: this.state.selectedOrganizationId,
  //   };
  //   await UpdateOrganization(org);


  // };

  // _handleOrgAdmin = async approvedAdmins => {
  //   approvedAdmins.map(admin => {
  //     admin.role = 'admin';
  //     admin.iconStatus = 'approved'
  //     const response = createUser(admin);
  //     console.log(response);

  //     return admin;
  //   });
  //   return '';
  // };

  // _blockOrganizationUsers = async () => {
  //   this.state.organizationUsers.map(user => {
  //     if (user.role.includes('admin')) {
  //       user.role = 'admin';
  //     } else {
  //       user.role = 'user';
  //     }
  //     createUser(user);



  //     return user;
  //   });
  //   return '';
  // };

  // _getApprovedAdmins = requestedAdmins => {
  //   const approvedAdmins = R.innerJoin(
  //     (record, key) => record.id === key,
  //     requestedAdmins,
  //     this.state.selectedRowKeys,
  //   );
  //   return approvedAdmins;
  // };

  // _getNonApprovedAdmins = (requestedAdmins, approvedAdmins) => {
  //   approvedAdmins.map(user => {
  //     // remove all approved admins from requested admin list
  //     requestedAdmins.splice(user.index, 1);
  //     return user;
  //   });
  //   return requestedAdmins;
  // };

  // _onSave = async () => {
  //   if (!this.state.action) {
  //     message.warning('you must select an Action');
  //     return;
  //   }
  //   const requestedAdmins = this.state.requestedAdmins;

  //   const approvedAdmins = this._getApprovedAdmins(requestedAdmins);
  //   const nonApprovedAdmins = this._getNonApprovedAdmins(
  //     requestedAdmins,
  //     approvedAdmins,
  //   );
  //   if (approvedAdmins.length === 0 && this.state.action === 'approved') {
  //     message.warning('you must select an org admin');
  //     return;
  //   }



  //   if (
  //     this.props.requestType === 'approved' &&
  //     this.state.action === 'denied'
  //   ) {
  //     await this._handleOrg();
  //     this._blockOrganizationUsers();
  //   } else {
  //     this._denyAdmin(nonApprovedAdmins);
  //     await this._handleOrg();
  //     this._handleOrgAdmin(approvedAdmins);
  //   }
  // };

  // _onClose = () => {
  //   this.setState({
  //     selectedRowKeys: [],
  //   });
  //   this._ToggleModal(false);
  // };


  // _onAdminClick = async orgInfo => {
  //   const res = await updateUserMetaData(this.props.auth.id, orgInfo.id);
  //   if (res) {
  //     // gotta remove the cookie or it will load the old cookie info on the redirect
  //     document.cookie = 'idToken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';

  //     window.location.replace(
  //       '/login?redirect=%2Fmemberadmin%2Fhome%2FviewUsers',
  //     );
  //   }
  // };

  render() {
    const { requests, requestType, refreshOrganizations, onUpdate } = this.props;
    // const { modalDisplayed } = this.state;
    const pageSize = 20;

    // Note that the grid configFile for this directory does not configure the request table, but the details table inside of the modal.
    const columns = [
      {
        Header: 'Organization Name',
        accessor: 'name',
        minWidth: 160,
        maxWidth: 220,
        filterPlaceholder: "search",
      },
      {
        Header: 'CAGE',
        accessor: 'cageCode',
        minWidth: 80,
        maxWidth: 120,
        filterPlaceholder: "search",
      },
      {
        Header: 'Industry Type',
        accessor: 'industryType',
        minWidth: 120,
        maxWidth: 180,
        filterPlaceholder: "search",
        Cell: ({ value }) => {
          if (Array.isArray(value)) {
            return value.join(' | ');
          }
          return value;
        },
      },
      {
        Header: 'Industry Affiliation',
        accessor: 'associationValidations',
        width: 150,
        filterPlaceholder: "search",
        Cell: ({ value }) => displayAssociations(value, ' | '),
      },
      {
        Header: 'Org Admin',
        accessor: 'admins[0].name',
        minWidth: 120,
        maxWidth: 170,
        filterPlaceholder: "search",
      },
      {
        Header: 'Email Address',
        accessor: 'admins[0].email',
        minWidth: 160,
        maxWidth: 220,
        filterPlaceholder: "search",
      },
      {
        Header: 'Phone Number',
        accessor: 'admins[0].phoneNumber',
        minWidth: 100,
        maxWidth: 150,
        filterPlaceholder: "search",
        Cell: ({ value }) => <div className="phone-number-column">{value}</div>,
      },
      {
        Header: 'Icon Status',
        accessor: 'iconStatus',
        minWidth: 110,
        maxWidth: 150,
        filterPlaceholder: "search",
      },
      ...(requestType === 'invited' || requestType === 'pending' ? [{
        Header: 'Date Invited',
        accessor: 'inviteDate',
        minWidth: 120,
        maxWidth: 160,
        filterPlaceholder: "search",
      }] : []),
      ...(requestType === 'pending' || requestType === 'approved' || requestType === 'denied' ? [{
        Header: 'Date Requested',
        accessor: 'requestDate',
        minWidth: 120,
        maxWidth: 160,
        filterPlaceholder: "search",
      }] : []),
      ...(requestType === 'approved' ? [{
        Header: 'Date Approved',
        accessor: 'approvalDate',
        minWidth: 120,
        maxWidth: 160,
        filterPlaceholder: "search",
      }, {
        Header: 'Modified By',
        accessor: 'modifiedByEmail',
        id: 'modifiedBy',
        minWidth: 180,
        maxWidth: 250,
        filterPlaceholder: "search",
        Cell: ({ original }) => {
          if (!original.modifiedByEmail) return '';
          return `${original.modifiedByEmail}${original.modifiedByRole ? ` (${original.modifiedByRole})` : ''}`;
        },
      }] : []),
      ...(requestType === 'denied' ? [{
        Header: 'Date Denied',
        accessor: 'deniedDate',
        minWidth: 120,
        maxWidth: 160,
        filterPlaceholder: "search",
      }, {
        Header: 'Modified By',
        accessor: 'modifiedByEmail',
        id: 'modifiedBy',
        minWidth: 180,
        maxWidth: 250,
        filterPlaceholder: "search",
        Cell: ({ original }) => {
          if (!original.modifiedByEmail) return '';
          return `${original.modifiedByEmail}${original.modifiedByRole ? ` (${original.modifiedByRole})` : ''}`;
        },
      }] : []),
      ...(isFeatureEnabled('ENABLE_BILLSBY') && requestType === 'approved' ? [{
        Header: 'Subscription Level',
        accessor: 'admins[0].subscriptionLevel',
        minWidth: 80,
        maxWidth: 100,
        filterPlaceholder: "search",
      }] : []),
      {
        Header: 'Action',
        id: 'row',
        accessor: 'action',
        filterMethod: otherFilter,
        filterPlaceholder: "search",
        minWidth: 120,
        maxWidth: 150,
        Cell: row => (
          <React.Fragment>
            {requestType === 'invited' && stage !== 'production' && (
              <LinkContainer to={`${invitationRoute}?orgId=${row.original.id}`}>
                <Button
                  title={titleAcceptInvitation}
                  type="default"
                  style={{ fontSize: '11px', margin: '7px' }}
                >
                  Accept Invitation
                </Button>
              </LinkContainer>
            )}
            {(requestType === 'Nffs' || requestType === 'Fia') && (
              <dev>
                <Button
                  title={titleView}
                  type="default"
                  style={{ fontSize: '11px', margin: '2px' }}
                  onClick={() => { this.openViewModal(row.original) }}
                >
                  View
                </Button>
                <Button
                  title={row.original.iconStatus === 'Approved' ? titleSync : (row.original.iconStatus || row.original.inviteDate ? titleUpdate : titleInvite)}
                  type="default"
                  style={{ fontSize: '11px', margin: '2px' }}
                  onClick={async () => {
                    const data = await sendInvitation(row.original);
                    onUpdate(data);
                  }}
                >
                  {row.original.iconStatus === 'Approved' ? 'Sync' : (row.original.iconStatus || row.original.inviteDate ? 'Update' : 'Invite')}
                </Button>
              </dev>
            )}
            {(requestType !== 'invited' && requestType !== 'Nffs' && requestType !== 'Fia') && (
              <dev>
                <Button
                  type="default"
                  onClick={() => {
                    this.openEditModal(row.original.id);
                  }}
                  style={{ fontSize: '11px', margin: '7px' }}
                >
                  {requestType === 'pending' ? (
                    <React.Fragment>
                      <FileSearchOutlined />
                      Review
                    </React.Fragment>
                  ) : (<React.Fragment>
                    <EditOutlined />
                    Edit
                  </React.Fragment>
                  )}
                </Button>
              </dev>
            )}
          </React.Fragment>
        ),
      },
    ];

    return (
      <div className="nf-view-users-grid view-organizations-table">
        <div className="responsive-table-container">
          <HorizontalScroll>
            <div id="div-wrapper" style={{ height: '100%' }}>
              <div style={{ width: '100%', maxWidth: '100%' }}>
                <ReactTable
                  data={PendingRequest.formatRequest(requests)}
                  columns={columns}
                  showPageSizeOptions
                  showPagination
                  noDataText={msgs.ViewPendingRequest.noDataText}
                  defaultPageSize={pageSize}
                  className="-striped -highlight"
                  // minRows={5}
                  resizable={false}
                  style={{
                    width: '100%',
                    height: '100%',
                    maxWidth: '100%'
                  }}
                  getTableProps={() => ({
                    style: {
                      width: '100%',
                      tableLayout: 'fixed'
                    }
                  })}
                  pageSizeOptions={[10, 20, 25, 50]}
                  defaultSortMethod={(a, b) => {
                    if (a === b) return 0;
                    return a < b ? -1 : 1;
                  }}
                  filterable
                  defaultFilterMethod={filterMethod}
                  getTheadFilterProps={() => ({
                    style: {
                      color: '#f00'
                    },
                  })}
                  getTheadFilterThProps={(state, rowInfo, column) =>
                  ({
                    title: column.Header === 'Action' ? tooltipRow : tooltipColumn,
                  })
                  }
                  getTheadThProps={() => ({
                    style: {
                      position: 'sticky',
                      top: 0,
                      zIndex: 1,
                      backgroundColor: '#fff',
                      whiteSpace: 'normal',
                      overflow: 'visible',
                      wordBreak: 'break-word',
                      verticalAlign: 'top'
                    }
                  })}
                  getTrProps={() => ({
                    style: {
                      display: 'table-row',
                      width: '100%'
                    }
                  })}
                  getTdProps={() => ({
                    style: {
                      whiteSpace: 'normal',
                      overflow: 'visible',
                      textOverflow: 'unset',
                      wordBreak: 'break-word',
                      verticalAlign: 'top'
                    }
                  })}
                  getTbodyProps={() => ({
                    style: {
                      overflowY: 'auto'
                    }
                  })}
                />
              </div>
            </div>
          </HorizontalScroll>
        </div>
        {this.state.showEditModal && this.state.selectedOrganizationId &&
          <EditOrganization
            selectedOrganizationId={this.state.selectedOrganizationId}
            showEditModal={this.state.showEditModal}
            auth={this.props.auth}
            closeEditModal={this.closeEditModal}
            refreshOrganizations={refreshOrganizations}
          />
        }
        {this.state.showViewModal && this.state.viewItem &&
          <ViewInvitation
            item={this.state.viewItem}
            showViewModal={this.state.showViewModal}
            closeViewModal={this.closeViewModal}
            onUpdate={onUpdate}
          />
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/grids/PendingRequest/PendingRequest.jsx